'use client'

import { ONTRACK_UNLOCK_MAGNET } from './unlock-magnet'
import { useLeadMagnetUnlocked } from '../../../hooks/use-lead-magnet-unlocked'
import { buildScheduleRedirectUrl, PAID_MEDIA_CALENDLY_URL } from '../../../utils/ctas'

/** Post-unlock CTAs skip /schedule_form (the visitor just submitted it) and go straight to Calendly, as on Coast. */
export const ONTRACK_CALENDLY_HREF = buildScheduleRedirectUrl(PAID_MEDIA_CALENDLY_URL, {})

/** LeadCaptureForm sets the cookie on reveal, which re-renders every subscriber (calculator + callout). */
export function useOnTrackUnlocked(): boolean {
  return useLeadMagnetUnlocked(ONTRACK_UNLOCK_MAGNET.slug)
}
